import { combineReducers } from 'redux';

import joinUiReducer from './joinUiReducer';
import joinDataReducer from './joinDataReducer';

export default combineReducers({
  ui: joinUiReducer,
  data: joinDataReducer,
});
